module.exports = __webpack_public_path__ + "img/top-banner-2.4e7f74d3.png";